var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83335 2.33334H2.33335C1.68585 2.33334 1.16669 2.85251 1.16669 3.50001V10.5C1.16669 11.1399 1.69344 11.6667 2.33335 11.6667H11.6667C12.3066 11.6667 12.8334 11.1399 12.8334 10.5V4.66668C12.8334 4.35726 12.7104 4.06051 12.4916 3.84172C12.2729 3.62293 11.9761 3.50001 11.6667 3.50001H7.00002L5.83335 2.33334Z",
    fill: "#FFB300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.cfede96994ebaa9eb371ad4d9e7f3540.svg";
export { ForwardRef as ReactComponent };